import React, { Component, Fragment } from "react";
import T from "prop-types";
import { connect } from "react-redux";

import { matchesBoolean, matchesString } from "LIB/filters";
import { DataTable } from "MODULES/shared/containers";
import {
  FilterSelect,
  Pagination,
  SearchFilter,
  TitleWithFilters
} from "MODULES/shared/components/Pagination";
import { Search } from "MODULES/shared/components";
import { STORE_LOCATION_ID } from "MODULES/inventories/constants";
import { USER } from "MODULES/users/constants";
import { CLEAR_FILTERS_TEXT } from "APP_ROOT/constants";
import DateRangePicker from "MODULES/shared/components/DateRangePicker/DateRangePicker";
import Create from "./Create/Container";
import Table from "./Table";
import DecoratedExportButton from "./ExportButton";
import pagination from "../../pagination";
import { subscribe, unsubscribe } from "../../actions";

const defaultFilters = {
  accounting_hold: undefined,
  courier_pickup: undefined,
  end_date: undefined,
  table: undefined,
  open_exchange: undefined,
  qc_under_review: undefined,
  qc_hold: undefined,
  released: undefined,
  returning_to_customer: undefined,
  store_location: undefined,
  start_date: undefined
};

const filters = [
  {
    label: "All ROs",
    filters: { table: "repair_order_line_items" }
  },
  {
    label: "All SOs",
    filters: { table: "sales_order_line_items" }
  },
  {
    label: "All Transfers",
    filters: { table: "inventory_transfer_orders" }
  },
  {
    label: "All Other",
    filters: { table: "other" }
  },
  {
    label: "Exchanges",
    filters: { open_exchange: true }
  },
  {
    label: "Mistake Shipments",
    filters: { table: "mistake_shipments" }
  },
  {
    label: "Returning To Customer",
    filters: { table: "shipments" }
  },
  {
    label: "Dropshipments",
    filters: { virtual_receiving: true }
  },
  {
    label: "QC Hold",
    filters: { qc_hold: true }
  },
  {
    label: "QC Under Review",
    filters: { qc_under_review: true }
  },
  {
    label: "Accounting Hold",
    filters: { accounting_hold: true }
  },
  {
    label: "Released",
    filters: { released: true }
  },
  {
    label: "Not Picked",
    filters: { picked: false }
  },
  {
    label: "Picked",
    filters: { picked: true }
  },
  {
    label: "Unreleased",
    filters: { released: false }
  },
  {
    label: "Courier PickUps",
    filters: { courier_pickup: true }
  }
];

const filterTags = [
  {
    label: "All ROs",
    key: "table",
    matchesTarget: matchesString("repair_order_line_items")
  },
  {
    label: "All SOs",
    key: "table",
    matchesTarget: matchesString("sales_order_line_items")
  },
  {
    label: "All Transfers",
    key: "table",
    matchesTarget: matchesBoolean("inventory_transfer_orders")
  },
  {
    label: "All Other",
    key: "table",
    matchesTarget: matchesString("other")
  },
  {
    label: "Dropshipments",
    key: "virtual_receiving"
  },
  {
    label: "Exchanges",
    key: "open_exchange"
  },
  {
    label: "Returning To Customer",
    key: "table",
    matchesTarget: matchesString("shipments")
  },
  {
    label: "All Mistake Shipments",
    key: "table",
    matchesTarget: matchesString("mistake_shipments")
  },
  {
    label: "QC Hold",
    key: "qc_hold"
  },
  {
    label: "QC Under Review",
    key: "qc_under_review"
  },
  {
    label: "Accounting Hold",
    key: "accounting_hold"
  },
  {
    label: "Released",
    key: "released",
    matchesTarget: matchesBoolean(true)
  },
  {
    label: "Unreleased",
    key: "released",
    matchesTarget: matchesBoolean(false)
  },
  {
    label: "Not Picked",
    key: "picked",
    matchesTarget: matchesBoolean(false)
  },
  {
    label: "Picked",
    key: "picked",
    matchesTarget: matchesBoolean(true)
  },
  {
    label: "Courier PickUps",
    key: "courier_pickup",
    matchesTarget: matchesBoolean(true)
  }
];

class Dashboard extends Component {
  static propTypes = {
    subscribeToOrdersChannel: T.func,
    unsubscribeToOrdersChannel: T.func
  };

  constructor(props) {
    super(props);

    this.openAndSetRecord = this.openAndSetRecord.bind(this);
  }

  componentDidMount() {
    const { subscribeToOrdersChannel } = this.props;

    subscribeToOrdersChannel();
  }

  componentWillUnmount() {
    const { unsubscribeToOrdersChannel } = this.props;

    unsubscribeToOrdersChannel();
  }

  openAndSetRecord = record => {
    if (this.createShippingForm) {
      this.createShippingForm.openAndSetRecord(record);
    }
  };

  createShippingFormRef = el => {
    this.createShippingForm = el;
  };

  render() {
    const { currentUser } = this.props;

    const filterTagsWithLocations = currentUser.toJS().locations.map(l => ({
      label: `${l.name} Store Location`,
      key: STORE_LOCATION_ID,
      matchesTarget: matchesString(l.id)
    }));

    const filtersWithLocations = currentUser.toJS().locations.map((l, i) => ({
      label: `${l.name} Store Location`,
      filters: { [STORE_LOCATION_ID]: l.id },
      hr: currentUser.toJS().locations.length - 1 === i
    }));

    return (
      <Fragment>
        <Search search={pagination} syncWithUrl>
          {searchProps => (
            <div>
              <div className="form-group form-group-searchbar has-feedback has-feedback-left">
                <i className="text-muted fa fa-search form-control-feedback form-control-feedback-left" />
                <div className="input-group">
                  <SearchFilter
                    {...searchProps}
                    placeholder="Search by typing a part number, company name or any reference number..."
                  />
                  <Create ref={this.createShippingFormRef} />
                  <DecoratedExportButton searchProps={searchProps} />
                  <DateRangePicker {...searchProps} />
                  <FilterSelect
                    {...searchProps}
                    filters={filters.concat(filtersWithLocations).concat({
                      label: CLEAR_FILTERS_TEXT,
                      filters: defaultFilters
                    })}
                    right
                  />
                </div>
              </div>
              <TitleWithFilters
                {...searchProps}
                title="Outbound Orders"
                filters={filterTags.concat(filterTagsWithLocations)}
              />
              <DataTable
                {...searchProps}
                component={Table}
                openModal={this.openAndSetRecord}
              />
              <Pagination {...searchProps} />
            </div>
          )}
        </Search>
      </Fragment>
    );
  }
}

export default connect(
  state => ({
    currentUser: state.session && state.session.get(USER)
  }),
  dispatch => ({
    subscribeToOrdersChannel: () => dispatch(subscribe()),
    unsubscribeToOrdersChannel: () => dispatch(unsubscribe())
  })
)(Dashboard);



// WEBPACK FOOTER //
// ./app/modules/Shipping/components/Dashboard/Dashboard.jsx